module.exports = __webpack_public_path__ + "static/media/logo-new.a6a485cd.png";